export const candidateAssessmentConstants = {
  GET_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST:
    "GET_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST",
  GET_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS:
    "GET_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS",
  GET_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE:
    "GET_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE",

  GET_ASSIGNED_ASSESSMENT_KITS_ACTION_REQUEST:
    "GET_ASSIGNED_ASSESSMENT_KITS_ACTION_REQUEST",
  GET_ASSIGNED_ASSESSMENT_KITS_ACTION_SUCCESS:
    "GET_ASSIGNED_ASSESSMENT_KITS_ACTION_SUCCESS",
  GET_ASSIGNED_ASSESSMENT_KITS_ACTION_FAILURE:
    "GET_ASSIGNED_ASSESSMENT_KITS_ACTION_FAILURE",

  GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST:
    "GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST",
  GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS:
    "GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS",
  GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE:
    "GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE",

  ACCEPT_ASSESSMENT_KIT_ACTION_REQUEST: "ACCEPT_ASSESSMENT_KIT_ACTION_REQUEST",
  ACCEPT_ASSESSMENT_KIT_ACTION_SUCCESS: "ACCEPT_ASSESSMENT_KIT_ACTION_SUCCESS",
  ACCEPT_ASSESSMENT_KIT_ACTION_FAILURE: "ACCEPT_ASSESSMENT_KIT_ACTION_FAILURE",

  DECLINE_ASSESSMENT_KIT_ACTION_REQUEST:
    "DECLINE_ASSESSMENT_KIT_ACTION_REQUEST",
  DECLINE_ASSESSMENT_KIT_ACTION_SUCCESS:
    "DECLINE_ASSESSMENT_KIT_ACTION_SUCCESS",
  DECLINE_ASSESSMENT_KIT_ACTION_FAILURE:
    "DECLINE_ASSESSMENT_KIT_ACTION_FAILURE",

  SUBMIT_ASSESSMENT_KIT_ACTION_REQUEST: "SUBMIT_ASSESSMENT_KIT_ACTION_REQUEST",
  SUBMIT_ASSESSMENT_KIT_ACTION_SUCCESS: "SUBMIT_ASSESSMENT_KIT_ACTION_SUCCESS",
  SUBMIT_ASSESSMENT_KIT_ACTION_FAILURE: "SUBMIT_ASSESSMENT_KIT_ACTION_FAILURE",

  GET_ASSESSMENT_NEXT_QUESTION_ACTION_REQUEST:
    "GET_ASSESSMENT_NEXT_QUESTION_ACTION_REQUEST",
  GET_ASSESSMENT_NEXT_QUESTION_ACTION_SUCCESS:
    "GET_ASSESSMENT_NEXT_QUESTION_ACTION_SUCCESS",
  GET_ASSESSMENT_NEXT_QUESTION_ACTION_FAILURE:
    "GET_ASSESSMENT_NEXT_QUESTION_ACTION_FAILURE",

  SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_REQUEST:
    "SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_REQUEST",
  SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_SUCCESS:
    "SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_SUCCESS",
  SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_FAILURE:
    "SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_FAILURE",

};
